import { useState, useEffect } from 'react';
import { RouterUrl } from 'routes';
import { getStorageItem, getUserUUIDToken, isAlreadyAuthorized, syncSentryContext } from 'utils';
import { getRegistrationStep } from 'api';
import { useAppDispatch } from '../store/hooks';
import { updateUserAction, updateUserAuthentication } from '../store/slices/user';
import { useNavigate } from 'react-router-dom';
import { REGISTRATION_TYPE } from '../constants';
import { useClearAllOnLogout } from './useClearAllOnLogout';
import { updateStepName } from 'store/slices/registration';
import { buildUserFromRegistrationStep, resolveRegistrationRoute } from 'utils/registrationStep';

export const useUpdateUserInfo = () => {
  const [loading, setLoading] = useState(true);
  const [step, setCurrentStep] = useState('');
  const [stepName, setStepName] = useState('');
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const clearAll = useClearAllOnLogout();

  const refetchUserInfo = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  useEffect(() => {
    let stillMounted = true;

    const updateUserRegistration = async () => {
      if (isAlreadyAuthorized()) {
        try {
          dispatch(updateUserAuthentication(true));

          const userUUID = getUserUUIDToken();
          const registrationType = getStorageItem(REGISTRATION_TYPE);
          const { data } = await getRegistrationStep();

          setStepName(data.step_name);
          dispatch(updateStepName(data.step_name));
          dispatch(
            updateUserAction({
              user: buildUserFromRegistrationStep(data, {
                userUUID,
                registrationType,
              }),
            }),
          );
          syncSentryContext({ phoneNumber: data.personal_info?.phone_number });

          setCurrentStep(resolveRegistrationRoute(data));
        } catch (error: any) {
          clearAll();
          setLoading(false);
          dispatch(updateUserAuthentication(false));
          setCurrentStep(RouterUrl.Login);
        } finally {
          setLoading(false);
        }
      } else {
        dispatch(updateUserAuthentication(false));
        setLoading(false);
        navigate(RouterUrl.Login);
      }
    };

    if (stillMounted) {
      updateUserRegistration();
    }

    return () => {
      stillMounted = false;
    };
  }, [refreshTrigger]);

  return { loading, step, setCurrentStep, setLoading, stepName, refetchUserInfo };
};
